<template>
  <div>
   
    <breadcrumbs></breadcrumbs>
    
    <div class="datd-abc">
      <div class="ind-title lh50 f16">
        <!-- <i class="el-icon-loading"></i> -->
        出库订单
      </div>
    </div>

    <div class="a7">
      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/a1.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.notCheckCount }}</div>
          <div class="a3">待分配线索(条)</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/a2.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.enableCount }}</div>
          <div class="a3">有效线索总数(条)</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/a3.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.disenableCount }}</div>
          <div class="a3">无效线索总数(条)</div>
        </div>
      </div>

      <div class="a1">
        <div>
          <img
            class="a1-img"
            src="../../assets/index/a4.png"
            alt=""
            srcset=""
          />
        </div>

        <div class="a4">
          <div class="a2">{{ arr.allCount }}</div>
          <div class="a3">线索总数(条)</div>
        </div>
      </div>
    </div>
    <div class="con-let"></div>
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="状态">
        <el-select v-model="state" placeholder="全部">
          <el-option label="待分配" value="0"></el-option>
          <el-option label="已分配" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="有效性">
        <el-select v-model="enable" placeholder="全部">
          <el-option label="有效" value="1"></el-option>
          <el-option label="无效" value="2"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="输入搜索" prop="name">
        <el-input v-model="keyword" placeholder="请输入申请人姓名/手机号"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getchaxu">查询</el-button>
        <el-button @click="getchonzi">重置</el-button>
      </el-form-item>

      <el-form-item>
        <!-- <el-button>导出</el-button> -->
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <el-table-column label="序号" prop="index" type="index">
      </el-table-column>

      <el-table-column label="申请人" prop="name"> </el-table-column>

      <el-table-column label="手机号" prop="phone"> </el-table-column>

      <el-table-column label="申请城市" prop="cityId"> </el-table-column>

      <!-- <el-table-column label="申请区域" prop="planCount"> </el-table-column> -->

      <el-table-column label="详细地址" prop="applyarea"> </el-table-column>

      <el-table-column label="状态" prop="state">
        <template slot-scope="scope">
          <div v-if="scope.row.state == 0">待分配</div>
          <div v-if="scope.row.state == 1">已分配</div>
        </template>
      </el-table-column>

      <el-table-column label="已分配业务员" prop="saleName"> </el-table-column>

      <el-table-column label="手机号" prop="salePhone"> </el-table-column>

      <el-table-column label="是否有效" prop="enable">
        <template slot-scope="scope">
          <div v-if="scope.row.enable == 1">有效</div>
          <div v-if="scope.row.enable == 2">无效</div>
        </template>
      </el-table-column>

      <el-table-column label="操作" prop="name" width="180">
        <template slot-scope="scope">
          <el-link
            style="margin: 0 10px"
            v-if="scope.row.enable == 1"
            type="primary"
            @click="getchukd(scope.row.backStopClueId)"
            >分配线索</el-link
          >

          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getyouxiao(scope.row.backStopClueId)"
            >有效</el-link
          >
          <el-link
            style="margin: 0 10px"
            type="primary"
            @click="getwuxiao(scope.row.backStopClueId)"
            >无效</el-link
          >

          <el-link type="primary" @click="getfuzi(scope.row)">复制</el-link>
          <el-link
            style="margin: 0 10px"
            v-if="scope.row.enable == 2"
            type="primary"
            @click="getchaokdd(scope.row.backStopClueId, scope.row.saleName)"
            >修改分配</el-link
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="mgt-10 pd-0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searlist.curPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="searlist.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    >
    </el-pagination>

    <el-dialog
      title="分配线索"
      :visible.sync="addORUpdateVisible2"
      width="750px"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="分配业务员">
          <el-select v-model="ruleForm.region" placeholder="请选择业务员">
            <el-option
              v-for="item in saleList"
              :key="item.saleId"
              :label="item.saleName"
              :value="item.saleId"
            >
            </el-option>
            <!--        
      <el-option label="区域一" value="shanghai"></el-option>
      <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click="getoym">取消</el-button>
        <el-button type="primary" @click="checkClue">确定分配</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改分配"
      :visible.sync="addORUpdateVisible1"
      width="750px"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="分配业务员">
          <el-select v-model="ruleForm.region" placeholder="请选择业务员">
            <el-option
              v-for="item in saleList"
              :key="item.saleId"
              :label="item.saleName"
              :value="item.saleId"
            >
            </el-option>
            <!--        
      <el-option label="区域一" value="shanghai"></el-option>
      <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>

      <div class="shanc">
        <el-button @click="getodd">取消</el-button>
        <el-button type="primary" @click="getyhx">确定分配</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import options from "../../../city.json";
export default {
  components: {
    breadcrumbs,
  },
  rules: {
    region: [{ required: true, message: "请输入业务员", trigger: "blur" }],
  },
  data() {
    return {
      oymyhx:[],
      oid: "",
      saleList: [],
      totalCount: 0,
      searlist: {
        curPage: 1,
        pageSize: 10,
      },
      arr: "",
      addORUpdateVisible1: false,
      addORUpdateVisible2: false,
      ruleForm: {
        region: "",
        name: "",
      },
      addORUpdateVisible: false,
      tableData: [{ planCount: "你好" }],
      shanghai: "",
      beijing: "",
      enable: "",
      keyword: "",
      state: "",

      copyData: null,

      searchForm: {
        name: "",
        region: "",
      },
    };
  },

  created() {

    console.log(options);
       this.oymyhx = options;
    this.getAddBackStopForm();
    this.getClueCount();

    this.getBackStopClueList(this.searlist.curPage, this.searlist.pageSize);
  },

  methods: {

   getoym(){
       this.addORUpdateVisible2 = false
        this.ruleForm={}

   },


   getodd(){

    this.addORUpdateVisible1=false
    this.ruleForm={}


   },





    getfuzi(row) {
      
      this.copyData =
        row.name +
        "--" +
        row.phone +
        "--" +
        row.cityId +
        "--" +
        row.applyarea +
        "--" +
        row.saleName;
      this.copy(this.copyData);
    },

    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
     
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },

    getwuxiao(id) {
      this.$api.activitymsg
        .updateClueState({
          clueId: id,
          enable: 2,
        })
        .then((e) => {
          if (e.code == 200) {
            this.getClueCount()
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getBackStopClueList(
              this.searlist.curPage,
              this.searlist.pageSize
            );
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    getyouxiao(id) {
      this.$api.activitymsg
        .updateClueState({
          clueId: id,
          enable: 1,
        })
        .then((e) => {
          if (e.code == 200) {

         this.getClueCount()
           


            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getBackStopClueList(
              this.searlist.curPage,
              this.searlist.pageSize
            );
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    getyhx() {
      this.$api.activitymsg
        .checkClue({
          clueId: this.oid,
          saleId: this.ruleForm.region,
        })
        .then((e) => {
          this.ruleForm={}
          if (e.code == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.getBackStopClueList(
              this.searlist.curPage,
              this.searlist.pageSize
            );
            this.addORUpdateVisible1 = false;

            (this.oid = ""), (this.ruleForm.region = "");
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    checkClue() {
      this.$api.activitymsg
        .checkClue({
          clueId: this.oid,
          saleId: this.ruleForm.region,
        })
        .then((e) => {
          if (e.code == 200) {

           this.ruleForm={},

            this.$message({
              message: "分配成功",
              type: "success",
            });
            this.getBackStopClueList(
              this.searlist.curPage,
              this.searlist.pageSize
            );
            this.addORUpdateVisible2 = false;

            (this.oid = ""), (this.ruleForm.region = "");
          } else {
            this.$message.error(e.msg);
          }
        });
    },

    getAddBackStopForm() {
      this.$api.activitymsg.getAddBackStopForm({}).then((e) => {
        this.saleList = e.data.saleList;
      });
    },

    getchonzi() {
      (this.enable = ""),
        (this.keyword = ""),
        (this.state = ""),
        this.getBackStopClueList(this.searlist.curPage, this.searlist.pageSize);
    },

    getchaxu() {
      this.getBackStopClueList(this.searlist.curPage, this.searlist.pageSize);
    },

    handleSizeChange(v) {
      this.searlist.pageSize = v;
      this.getBackStopClueList(this.searlist.curPage, v);
    },
    handleCurrentChange(v) {
      this.searlist.curPage = v;

      this.getBackStopClueList(v, this.searlist.pageSize);
    },

    getBackStopClueList(curr, pagesize) {
      this.$api.activitymsg
        .getBackStopClueList({
          current: curr,
          size: pagesize,
          enable: this.enable,
          keyword: this.keyword,
          state: this.state,
        })
        .then((e) => {

         

         e.data.map(item=>{

           this.oymyhx.map(item1=>{
              item1.child.map(item2=>{
                   if (item2.regionId== item.cityId) {
                      item.cityId=item2.regionName
                  console.log("123",item2.regionId,item.cityId);
               }
              })



         
           })
             
            
            
         })











          this.tableData = e.data;
          this.totalCount = e.totalCount;
        });
    },

    getClueCount() {
      this.$api.activitymsg.getClueCount({}).then((e) => {
        this.arr = e.data;
      });
    },

    getchukd(id) {
      this.oid = id;
      this.addORUpdateVisible2 = true;
    },

    getchaokdd(oid, nane) {
      (this.oid = oid),
        (this.ruleForm.region = nane),
        (this.addORUpdateVisible1 = true);
    },

    getchakxq() {
      this.$router.push("orderitem");
    },
  },
};
</script>

<style scoped>
.hjjkun {
  display: flex;
  justify-content: flex-end;
  height: 40px;
  align-content: center;
}

.shanc {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nhpl {
  height: 10px;
}

.wohk {
  width: 100%;
  background: #e9e9e9;
  border: 1px solid var(--input-border);
  opacity: 1;
}

.tt2 {
  width: 95%;
  height: 50px;

  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tt1 {
  width: 95%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.con-let {
  height: 50px;
}

.a7 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.a4 {
  margin-left: 20px;
}

.a3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  color: var(--text-main);
  opacity: 1;
}

.a2 {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: var(--text-main);
  opacity: 1;
}

.a1-img {
  width: 100px;
  height: 100px;
}
.a1 {
  width: 260px;
  height: 127px;
  opacity: 1;
  border-radius: 10px;
  border: solid 1px var(--table-border);
  display: flex;
  align-items: center;
  padding: 0 20px;
}
</style>
